import "./portfolio.css";

import Image1 from "../../assets/image1.jpg";
import image2 from "../../assets/image2.png"
import image3 from "../../assets/image3.png"
import React from "react";

//Portfolio function
const Portfolio = () => {
  const soloProjects = [
    {
      id: 1,
      title: "Educational Website with React.js",
      img: Image1,
      description:
        "An educational website is a huge interactive platform to present various information for people.",
      technologies: "Html | CSS | Javascript | React Js",
      link: "https://educational-website-reactjs.netlify.app/",
      github: "https://github.com/Rasif-Taghizada/Educational-Website-ReactJs",
    },
    {
      id: 2,
      title: "NCC Website with React.js",
      img: image2,
      description:
        "An NCC website is a platform to present various information for students so that they can join NCC.",
      technologies: "Html | CSS | Javascript | Bootstrap",
      link: "https://anshima009.github.io/ncc_websit.github.io/",
      //github: "https://github.com/Rasif-Taghizada/Educational-Website-ReactJs",
    },
    
    {
      id: 3,
      title: "Cosmic application ",
      img: image3,
      description:
        "A cosmic website is a platform to present regular information regarding universe and space-related information.",
      technologies: "Html | CSS | JavaScript | Nasa Apod API",
      link: "https://anshima09.github.io/Cosmic-Web-Application/",
      //github: "https://github.com/Rasif-Taghizada/fh-huquq.com",
    },
   
  ];

  return (
    <section id="portfolio">
      <h5>My Recent Work</h5>
      <h2>Portfolio</h2>

      <div className="container portfolio__container">
        {soloProjects.map((pro) => (
          <article className="portfolio__item" key={pro.id}>
            <div className="portfolio__item-image">
              <img src={pro.img} alt={pro.title} />
            </div>
            <div className="portfolio__item-content">
              <h3>{pro.title}</h3>
              <p>{pro.description}</p>
              <p>{pro.technologies}</p>
            </div>
            <div className="portfolio__item-cta">
              {/* <a
                href={pro.github}
                target="_blank"
                className="btn"
                rel="noreferrer"
              >
                GitHub
              </a> */}
              <a
                href={pro.link}
                target="_blank"
                className="btn btn-primary"
                rel="noreferrer"
              >
                Live Demo
              </a>
            </div>
          </article>
        ))}
      </div>
    </section>
  );
};

export default Portfolio;
